/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ResetTokenPathParams = NonNullable<operations['resetToken']['parameters']['path']>;

export type ResetTokenQueryParams = NonNullable<operations['resetToken']['parameters']['query']>;

export interface Input extends ResetTokenPathParams {
  apiVersion?: string;
  query?: ResetTokenQueryParams;
}

/** @deprecated */
export async function resetToken(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/tokens/{id}/reset', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
